import { ProductOfferingFormOption, ProductOfferingFormOptionItem } from "types";

export const getOptionTotal = (option: ProductOfferingFormOption): number => {
  return option.items.reduce((total: number, item: ProductOfferingFormOptionItem) => {
    return total + (+item.unitPrice * +item.quantity || 0);
  }, 0);
};
